import React from 'react'
import cx from 'classnames'

import darkLogo, { ReactComponent as DarkLogoSVG } from './images/black.svg'
import lightLogo, { ReactComponent as LightLogoSVG } from './images/white.svg'

import s from './Logo.scss'


type LogoProps = {
  className?: string
  light?: boolean
  dark?: boolean
  inline?: boolean
}

const Logo: React.FunctionComponent<LogoProps> = ({ className, light, dark, inline }) => {
  if (!light && !dark) {
    console.error('Missed light or dark property in Logo component')
    return null
  }

  const LogoSVG = light ? LightLogoSVG : DarkLogoSVG
  const src     = light ? lightLogo : darkLogo

  return inline ? (
    <LogoSVG className={cx(className, s.svgLogo)} />
  ) : (
    <img className={className} src={src} alt="Scentbird logo" />
  )
}


export default React.memo(Logo)
